import React, { useMemo, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ReactHtmlParser from 'react-html-parser'
import { useColumnsCI } from '../../../common/tableHeaders'
import useStaticData from '../../../common/useStaticData'
import { handleCIOrder } from '../../../common/handleOrders'
import TableView from '../../../components/TableView'
import Button from '../../../../../components/Button'
import { RelatedImageList } from '../../../components'
import CheckboxBlock from '../../../../../legacy/components/CheckboxBlock'

const CrackInjectionOutput = () => {
  const dispatch = useDispatch()
  const calculation = useSelector((state) => state.calculation)
  const staticData = useSelector((state) => state.staticData)
  const { mobileViewOrderCounter } = calculation.status

  const { injectionResin, pasteOverEpoxy, pumpingPortStyle } = calculation.input
  const {
    source,
    injectionResinModel,
    pasteOverEpoxyModel,
    pumpingPortModel,
    injectionFittingModel,
  } = calculation.input
  const {
    injectionResinResults,
    pasteOverEpoxyResults,
    pumpingPortsResults,
    injectionFittingsResults,
  } = calculation.output

  const {
    handleAnchorClick,
    headerInjectionResin,
    headerPasteOverEpoxy,
    headerPumpingPorts,
    headerInjectionFittings,
  } = useColumnsCI()
  const { getCrackInjectionFootnotes, getProductImages } = useStaticData(staticData)

  const relatedImageItems = [pasteOverEpoxy !== 'none' ? pumpingPortStyle : ''].concat([
    'CIMixingNozzles',
    'CIDispensingTools',
  ])
  const relatedImages = getProductImages(relatedImageItems)

  const handleOrderChange = (name, model) => {
    dispatch({ type: 'FIELD_UPDATE_CALCULATION', payload: { [name]: model } })
  }

  const OrderCheckbox = (props) => {
    return (
      <CheckboxBlock
        name={props.model}
        value={props.model === props[props.name]}
        onChange={(e) => handleOrderChange(props.name, props.model)}
      />
    )
  }

  const tableWithNotes = useMemo(() => {
    const pumpingPortModels = pumpingPortsResults.reduce(
      (result, item) => result.concat([item.model]),
      [],
    )
    const fittingModels = injectionFittingsResults.reduce(
      (result, item) => result.concat([item.model]),
      [],
    )

    const injectionResinNotes = getCrackInjectionFootnotes([injectionResin])
    const pasteOverEpoxyNotes =
      pasteOverEpoxy !== 'none' ? getCrackInjectionFootnotes([pasteOverEpoxy]) : []
    const pumpingPortNotes =
      pasteOverEpoxy !== 'none'
        ? getCrackInjectionFootnotes(pumpingPortModels.concat([pumpingPortStyle]))
        : []
    const injectionFittingsNotes =
      pasteOverEpoxy !== 'none' ? getCrackInjectionFootnotes(fittingModels) : []

    const columnData = [
      {
        name: 'injectionResinModel',
        injectionResinModel: injectionResinModel,
      },
      {
        name: 'pasteOverEpoxyModel',
        pasteOverEpoxyModel: pasteOverEpoxyModel,
      },
      {
        name: 'pumpingPortModel',
        pumpingPortModel: pumpingPortModel,
      },
      {
        name: 'injectionFittingModel',
        injectionFittingModel: injectionFittingModel,
      },
    ]

    const modelColumnList = columnData.map((item) => {
      return [
        {
          Header: 'Model',
          accessor: 'model',
          Cell: (row) => (
            <>
              {source === 'EC' ? <OrderCheckbox model={row.cell.value} {...item} /> : null}
              <a
                name={row.cell.value}
                href={row.row.original.productUrl || 'TBD'}
                target="_blank"
                onMouseDown={(e) => handleAnchorClick(e, row, source)}
              >
                {row.cell.value}
              </a>
            </>
          ),
        },
      ]
    })

    const tableData = [
      {
        title: 'Injection Resin',
        columns: modelColumnList[0].concat(headerInjectionResin),
        data: injectionResinResults,
        notes: injectionResinNotes,
      },
      {
        title: 'Paste-Over Epoxy',
        columns: modelColumnList[1].concat(headerPasteOverEpoxy),
        data: pasteOverEpoxyResults,
        notes: pasteOverEpoxyNotes,
      },
      {
        title: 'Pumping Ports',
        columns: modelColumnList[2].concat(headerPumpingPorts),
        data: pumpingPortsResults,
        notes: pumpingPortNotes,
      },
      {
        title: 'Injection Fittings',
        columns: modelColumnList[3].concat(headerInjectionFittings),
        data: injectionFittingsResults,
        notes: injectionFittingsNotes,
      },
    ]
    return pasteOverEpoxy !== 'none' ? tableData : tableData.slice(0, 1)
  }, [
    injectionResinResults,
    pasteOverEpoxyResults,
    pumpingPortsResults,
    injectionFittingsResults,
    injectionResin,
    pasteOverEpoxy,
    pumpingPortStyle,
    injectionResinModel,
    pasteOverEpoxyModel,
    pumpingPortModel,
    injectionFittingModel,
  ])

  useEffect(() => {
    if (mobileViewOrderCounter >= 0) {
      handleCIOrder(calculation.output, calculation.input)
    }
  }, [mobileViewOrderCounter])

  return (
    <>
      {calculation.output && (
        <section>
          {tableWithNotes &&
            tableWithNotes.length > 0 &&
            tableWithNotes.map((item, idx) => {
              const { notes, ...rest } = item

              return (
                <section key={`${item.title}-${idx}`}>
                  <TableView {...rest} />
                  {notes && notes.length > 0 && (
                    <section>
                      <ul>{ReactHtmlParser(notes.join('').replace(/\\/g, ''))}</ul>
                    </section>
                  )}
                </section>
              )
            })}

          <section id="aceCrackProducts2">
            <h4>Related Products</h4>
            <div>
              <RelatedImageList
                source={source}
                relatedImages={relatedImages}
                injectionResin={injectionResin}
                pasteOverEpoxy={pasteOverEpoxy}
              />
            </div>
          </section>

          {source === 'EC' ? (
            <div className="aceProductOutput__orderButtonWrapper">
              <Button
                variant="primary"
                onClick={(e) => handleCIOrder(calculation.output, calculation.input)}
              >
                <span className="button__text">Order</span>
                <span className="material-icons">chevron_right</span>
              </Button>
            </div>
          ) : null}
        </section>
      )}
    </>
  )
}

export default CrackInjectionOutput
